import React, {Component} from "react";
import {Input, Modal} from "antd";
import DrawPad from "../../components/DrawPad";
import * as api from "../../api/product_location";


class ProductLocationMapModal extends Component {

    state = {
        saving: false,
        selected: undefined,
        locationNo: undefined,
        locations: []
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.record && this.props.record.id !== (prevProps.record || {}).id) {
            this.onLoad(this.props.record.id)
        }
    }

    onLoad = (areaId) => {
        api.getProductLocationMaps(areaId).then(response => {
            const locations = response.data.data.map(location => ({
                ...location,
                points: location.points.split(';').map(i => {
                    const [a, b] = i.split(',')
                    return {x: a, y: b}
                }),
                fill: '#0000ffaa'
            }))
            this.setState({locations})
        })
    }

    onDrawAdd = (points) => {
        this.setState({
            selected: {
                points: points
            }
        })
    }

    onDrawItemClick = (item) => {
        this.setState({
            selected: item,
            locationNo: item.location_no
        })
    }

    onAdd = () => {
        this.setState({saving: true})
        api.modifyProductLocationMap({
            area_id: this.props.record.id,
            ...this.state.selected,
            points: this.state.selected.points.map(item => item.x + ',' + item.y).join(";"),
            location_no: this.state.locationNo,
        }).then(() => {
            this.setState({saving: false, selected: undefined})
            this.onLoad(this.props.record.id)
        }).catch(() => {
            this.setState({saving: false})
        })
    }

    render() {
        const {record = {}, ...otherProps} = this.props
        return (
            <Modal {...otherProps} width={'90%'} footer={null}>
                <DrawPad style={{height: '90vh'}}
                         image={record.image}
                         imageWidth={record.width} imageHeight={record.height}
                         onAdd={this.onDrawAdd}
                         onItemClick={this.onDrawItemClick}
                         areas={this.state.locations}
                />
                <Modal visible={!!this.state.selected} confirmLoading={this.state.saving} onOk={this.onAdd}
                       onCancel={() => {
                           this.setState({selected: undefined, locations: [...this.state.locations]})
                       }}>
                    <Input value={this.state.locationNo}
                           onChange={event => this.setState({locationNo: event.target.value})}
                           placeholder={'请输入库位编号'}/>
                </Modal>

            </Modal>
        );
    }
}

export default ProductLocationMapModal